import SessionManager from '../session-manager';

const SubscriptionSyncService = {
	KEYS: {
		LAST_SUBSCRIPTION_SYNC: 'climatempo_last_subscription_sync',
	},

	SYNC_INTERVAL_MS: 60 * 1000,
	_syncIntervalId: null,

	getPlanName(data) {
		return data?.planName || data?.subscription?.planName || null;
	},

	canSync(force = false) {
		if (force) {
			return true;
		}

		const lastSync = parseInt(
			localStorage.getItem(this.KEYS.LAST_SUBSCRIPTION_SYNC) || '0',
			10,
		);
		const now = Date.now();

		return now - lastSync >= this.SYNC_INTERVAL_MS;
	},

	markSyncTimestamp() {
		localStorage.setItem(
			this.KEYS.LAST_SUBSCRIPTION_SYNC,
			Date.now().toString(),
		);
	},

	clearSyncTimestamp() {
		localStorage.removeItem(this.KEYS.LAST_SUBSCRIPTION_SYNC);
	},

	async syncPlan(apiClient, force = false) {
		if (!apiClient || !SessionManager.getAccessToken()) {
			return null;
		}

		if (!this.canSync(force)) {
			return null;
		}

		try {
			this.markSyncTimestamp();
			const result = await apiClient.bffGet('/v1/subscriptions/status', {
				requiresAuth: true,
			});

			if (!result?.success) {
				return null;
			}

			const planName = this.getPlanName(result.data);
			if (!planName) {
				return null;
			}

			SessionManager.updateSubscriptionPlan(planName);
			return planName;
		} catch (error) {
			console.error('Erro ao sincronizar plano de assinatura:', error);
			return null;
		}
	},

	startAutoSync(apiClient) {
		if (!apiClient || !SessionManager.getAccessToken()) {
			return;
		}

		this.syncPlan(apiClient, true);

		if (this._syncIntervalId) {
			return;
		}

		this._syncIntervalId = setInterval(() => {
			this.syncPlan(apiClient);
		}, this.SYNC_INTERVAL_MS);
	},

	stopAutoSync() {
		if (!this._syncIntervalId) {
			return;
		}

		clearInterval(this._syncIntervalId);
		this._syncIntervalId = null;
	},
};

export default SubscriptionSyncService;
